export const BILLER_SIDEBAR = [
  { slug: 'title', name: 'Home' },
  { slug: 'link', name: 'POS', href: '/pos', icon: 'cilCalculator' },
  // The shared /pos-sales report endpoint already scopes results to the
  // logged-in user when their role is `biller` (see orderController::
  // posSalesReport), so the biller naturally sees only their own bills.
  // We rename the label here so it reads truthfully in their sidebar.
  { slug: 'link', name: 'My POS Sales', href: '/pos-sales', icon: 'cilReceipt' },
  // Orders.vue swaps to BILLER_TABS for this role: Search + My All +
  // My Returned + My Cancelled, all auto-scoped to the caller's user_id
  // by the backend. No separate route needed.
  { slug: 'link', name: 'Orders', href: '/orders', icon: 'cilBox' },
  { slug: 'link', name: 'HMS Import', href: '/hms_imports', icon: 'cilCloudUpload' },

  { slug: 'title', name: 'Resources' },
  { slug: 'link', name: 'Info Center', href: '/info-center', icon: 'cilLibrary' },
  { slug: 'link', name: 'Private Notes', href: '/private-notes', icon: 'cilNote' },
]
